import { DtGeolocation } from '@ow/ditto-core'

const { config } = DtGeolocation

export { default as Render } from './render'
export { config }
